import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const identityRoutes = {
  [ERouteMappingKeys.IDENTITY]: {
    id: "identity",
    path: "/identity",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Identity/Identity").then((p) => ({
          default: p.Identity,
        })),
      ),
      /**
       * Special case/request for the desktop QR code pairing page
       * @see https://ui.slack.com/archives/GMDLV5QPN/p1747722286236019?thread_ts=1742182262.626689&cid=GMDLV5QPN
       */
      "qrcode/desktop/bt_pairing": lazy(() =>
        import("pages/Sections/Identity/Identity").then((p) => ({
          default: p.Identity,
        })),
      ),
    },
  },
};
